import SigliveServiceV1 from 'Service/sigliveServiceV1';

const getPresences = async () => {
  const { data } = await SigliveServiceV1({ method: 'GET', url: '/monitoring-host/presences' });

  return data?.data;
};

export default getPresences;
